import { FC, memo } from "react";
import "./Inputs.scss";

/**
 * CheckboxWithIcon Props Interface
 * @interface CheckboxWithIconProps
 */

interface CheckboxWithIconProps {
  /** Label text color */
  labelColor: string
  /** Checkbox label text */
  label: string
  /** Unique identifier for the checkbox */
  id: string
  /** Add class name for icons */
  iconClass: string
}

const CheckboxWithIcon: FC<CheckboxWithIconProps | any> = ({
  labelColor,
  label,
  id,
  iconClass,
  ...props
}) => {
  return (
    <div className={`checkbox-icon`}>
      <input
        className={`checkbox-icon-input`}
        type="checkbox"
        id={id}
        {...props}
      />
      <label htmlFor={id} className={`checkbox-icon-label`}>
        {label || ""}
        {iconClass && <span className={iconClass}></span>}
      </label>
    </div>
  );
};

export default memo(CheckboxWithIcon)
